import {BaseModel} from '../../_base/crud';

export class AssetClassType extends BaseModel {
    id: number;
    name: string;
    hide_flag: number;
    relation_cnt: number;
    is_hidden: boolean;
    is_system_entry: boolean;
    facilities: any[];
    top_property_type_id: number;
    top_property_type_name: string;

    created_at: Date;
    updated_at: Date;
    deleted_at: Date;

    deletedBy: string;
    user_deleted: Date;
    userDeletedBy: string;

    clear(): void {
        this.id = undefined;
        this.name = '';
        this.hide_flag = 0;
        this.relation_cnt = 0;
        this.is_hidden = false
        this.is_system_entry = false
        this.facilities = [];
        this.top_property_type_id = null;
        this.top_property_type_name = null;

        this.created_at = new Date();
        this.updated_at = new Date();
        this.deleted_at = null;

        this.deletedBy = '';
        this.userDeletedBy = '';
        this.user_deleted = new Date();
    }
}
